export const STEP_VERIFY_PASSWORD_RESET_CODE = 'VERIFY_PASSWORD_RESET_CODE';
export const STEP_SET_PASSWORD_AND_VERIFY_EMAIL = 'STEP_SET_PASSWORD_AND_VERIFY_EMAIL';
export const STEP_SET_PASSWORD_AND_VERIFY_EMAIL_SUCCESS = 'STEP_SET_PASSWORD_AND_VERIFY_EMAIL_SUCCESS';

